export const COMPARES_ACTION = {
  LIST: 'LIST_COMPARES',
  CREATE: 'CREATE_COMPARES',
  DELETE: 'DELETE_COMPARES',
  VIEW: 'VIEW_COMPARES',
  DELETE_ALL: 'DELETE_ALL_COMPARES',
  HIERARCHICAL: 'HIERARCHICAL_COMPARES',
  PRODUCTS: 'CATEGORY_PRODUCTS_COMPARE'
};